
































import { Octokit } from '@octokit/rest'
import Marked from 'marked'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
  },
})
export default class ReleaseNotes extends Vue {
  public Releases = new Array<any>();
  public Loading = true;

  constructor() {
    super();
    this._fetch();
  }

  public Html(markdown: string): string {
    return Marked(markdown);
  }

  private async _fetch(): Promise<void> {
    const octokit = new Octokit();
    const result = await octokit.rest.repos.listReleases({
      owner: 'Ealenn',
      repo: 'LarbinBot'
    });
    this.Releases = result.data;
    this.Loading = false;
  }
}
